import {
  EXAM_RENDER_TYPE,
  otmUserServerUrl,
  USER_V3_STATE_TYPE,
} from '@/js/common/constants';
import {getUrlParams, getParameterByName} from '@/js/common/util';
import {mapActions, mapGetters} from 'vuex';

export default {
  data() {
    return {
      returnUrl:
        getParameterByName('returnUrl') || getParameterByName('return_url'),
      failUrl: getParameterByName('failUrl') || getParameterByName('fail_url'),
    };
  },

  computed: {
    ...mapGetters({
      periodInfo: 'user/getPeriod',
    }),
  },
  methods: {
    ...mapActions({
      getExamPeriod: 'user/getExamPeriod',
    }),

    async moveExamRoom() {
      const {companyId, hash, examPeriodId} = this.userInfo;
      const period = await this.getExamPeriod(examPeriodId);
      let params = {};
      const PeriodLinkUrl = period.linkUrl;

      if (companyId) params.companyId = companyId;
      if (hash) params.hash = hash;
      if (examPeriodId) params.examPeriodId = examPeriodId;
      // 시간 체크 후 시험장 보내는 조건이 다름
      if (this.examInfo.renderType === EXAM_RENDER_TYPE.EXAM_WORLD_IFRAME) {
        this.renderType4();
        return;
      }

      if (this.returnUrl) {
        location.replace(this.returnUrl);
        return;
      }

      if (this.examInfo.renderType === EXAM_RENDER_TYPE.EXAM_IFRAME) {
        this.renderType3();
        return;
      }

      if (this.examInfo.renderType === EXAM_RENDER_TYPE.EXAM_FORM) {
        this.renderType2(PeriodLinkUrl);
        return;
      }

      this.renderType1(PeriodLinkUrl);
    },

    renderType1(PeriodLinkUrl) {
      if (PeriodLinkUrl === null || PeriodLinkUrl === '') {
        location.href = `${window.location.origin}/pages/exam_room.html${window.location.search}`;
        return;
      }

      if (PeriodLinkUrl.includes('?')) {
        location.href = `${PeriodLinkUrl}&userid=${this.userInfo.id}`;
        return;
      }

      location.href = `${PeriodLinkUrl}${window.location.search}`;
    },

    renderType2(PeriodLinkUrl) {
      let form = document.createElement('form');
      const linkUrl = PeriodLinkUrl.split('?')[0];
      const queryParams = getUrlParams(PeriodLinkUrl);
      const formValues = {
        user_key: this.userInfo.email,
        userid: this.userInfo.id,
        user_pw: this.userInfo.hash,
      };
      if (Object.keys(queryParams).length > 0) {
        Object.keys(queryParams).map(function (key) {
          formValues[key] = queryParams[key];
        });
      }
      Object.keys(formValues).map(function (key) {
        let hidden = document.createElement('input');
        hidden.setAttribute('type', 'hidden');
        hidden.setAttribute('name', key);
        hidden.setAttribute('value', formValues[key]);
        form.appendChild(hidden);
      });
      form.setAttribute('action', linkUrl);
      form.setAttribute('method', 'GET');
      form.setAttribute('target', '_self');
      document.body.appendChild(form);
      form.submit();
    },

    renderType3() {
      this.moveExamRoomIframe();
    },

    renderType4() {
      const isExamTimeOver = this.isExamTimeOver();

      if (!isExamTimeOver) {
        window.location.href = this.returnUrl;
        return;
      }

      this.moveExamRoomIframe();
    },

    isExamTimeOver() {
      const {periodStart, enterMinAgo} = this.periodInfo;
      console.log('first', this.periodInfo);
      const now = this.$dayjs();
      const periodStartSubtract = this.$dayjs(periodStart).subtract(
        enterMinAgo,
        'minutes',
      );
      return now.isAfter(periodStartSubtract);
    },

    moveExamRoomIframe() {
      location.href = `${otmUserServerUrl}/${USER_V3_STATE_TYPE.EXAM_ROOM_IFRAME}${window.location.search}&companyid=${this.userInfo.companyId}`;
    },
  },
};
